import { Button } from "@mui/material";
import { FC } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import i18n from "../../locales/i18n";
import { isExists } from "../../utils";

interface IExportButton {
  data: any;
  filename: string;
  style?: any;
  icon?: string;
}

const ExportButton: FC<IExportButton> = (props) => {
  const { t } = useTranslation();
  const headers = generateHeaders(props.data);

  return (
    <Button className="btn btn-light" style={props.style}>
      <CSVLink
        data={props.data}
        filename={`${props.filename}.csv`}
        headers={headers}
        //asyncOnClick={true}
        //onClick={(event, done) => clickHandler(data, done)}
      >
        <i className={props.icon}></i>
        {t("export")}
      </CSVLink>
    </Button>
  );
};

function generateHeaders(data: any) {
  let headers: any = [];
  data.forEach((item: any) => {
    Object.entries(item).forEach(([label, v]: any) => {
      if (typeof item[label] === "object") {
        if (isExists(item[label])) {
          Object.entries(item[label]).forEach(([y, z]: any) => {
            if (y === "0") {
              let obj = {
                label: `${i18n.t(Object.keys(z)[0])}`,
                key: `${label}.${y}.${Object.keys(z)[0]}`,
              };
              headers.push(obj);
            } else {
              let obj = {
                label: `${i18n.t(label)}.${i18n.t(y)}`,
                key: `${label}.${y}`,
              };
              headers.push(obj);
            }
          });
        }
      } else {
        let obj = { label: i18n.t(label), key: label };
        headers.push(obj);
      }
    });
  });

  let uniqueHeaders: any = headers.slice(headers.length / 2, headers.length);
  /* uniqueHeaders = [
    ...new Map(
      uniqueHeaders.map((item: any) => [item["label"], item])
    ).values(),
  ]; */

  return uniqueHeaders;
}

export default ExportButton;
